import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { useSiteAboutData } from "../hooks/useSiteData";
import { type } from "../lib/typography";

export default function CtaBanner() {
  const { data: companyInfo = { primaryPhone: "" } } = useSiteAboutData();

  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[#0a1a2f]" />
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#1e6fcf]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-10">
        <div className="max-w-2xl text-center lg:text-left">
          <div className="flex items-center gap-3 justify-center lg:justify-start">
            <span className="w-10 h-0.5 bg-[#1e6fcf]" />
            <span className={`text-[#aad4fa] ${type.eyebrow}`}>
              Let&apos;s Build Together
            </span>
          </div>
          <h2 className={`mt-4 ${type.sectionTitle} text-white`}>
            Ready to strengthen your <span className="text-[#aad4fa]">next project?</span>
          </h2>
          <p className={`mt-4 ${type.lead} text-slate-300 max-w-xl`}>
            Get an expert structural assessment and a detailed proposal tailored to your site.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
          <Link
            to="/contact"
            className="group inline-flex items-center justify-center gap-2 bg-[#1e6fcf] hover:bg-[#1758a8] text-white font-bold px-7 py-4 rounded-lg shadow-2xl shadow-[#1e6fcf]/35 transition-all duration-300"
          >
            Request a Quote
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          {companyInfo.primaryPhone ? (
            <a
              href={`tel:${companyInfo.primaryPhone}`}
              className="inline-flex items-center justify-center gap-2 border-2 border-white/25 hover:border-[#aad4fa] hover:bg-white/5 text-white font-bold px-7 py-4 rounded-lg backdrop-blur-sm transition-all duration-300"
            >
              <Phone className="w-4 h-4" />
              {companyInfo.primaryPhone}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
